<div class="file-manager-plugins">
    <p-button label="LINKELÉSI NAPLÓ" icon="pi pi-link" severity="secondary" [outlined]="true" size="small"
        styleClass="right-panel__btn--outline" [disabled]="false" (onClick)="openLinkLog()" />
    <p-button label="FELTÖLTÉSI NAPLÓ" icon="pi pi-history" severity="secondary" [outlined]="true" size="small"
        styleClass="right-panel__btn--outline" [disabled]="false" (onClick)="openUploadLog()" />
</div>

<p-dialog
    header="Linkelési napló"
    [visible]="showFileOps()"
    (visibleChange)="showFileOps.set($event)"
    [modal]="true"
    [maximizable]="true"
    [style]="{width: '90vw', height: '90vh'}"
    [contentStyle]="{height: '100%', display: 'flex', flexDirection: 'column'}"
>
    <div class="p-4 border-bottom-1 surface-border">
        <p-iconField iconPosition="left">
            <p-inputIcon styleClass="pi pi-search" />
            <input name="linkLogFilterText" type="text" pInputText placeholder="Szűrés (aktuális oldalon)..." [ngModel]="logFilterText()" (ngModelChange)="logFilterText.set($event)" class="w-full" />
        </p-iconField>
    </div>
    <div class="flex-1 overflow-hidden">
        @if (showFileOps()) {
        <p-table
            [value]="filteredLinkEntries()"
            [lazy]="true"
            (onLazyLoad)="onLinkLazyLoad($event)"
            [paginator]="true"
            [rows]="linkMeta()?.per_page ?? 15"
            [totalRecords]="linkMeta()?.total ?? 0"
            [loading]="linkLoading()"
            [scrollable]="true"
            scrollHeight="flex"
            styleClass="p-datatable-sm"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Esemény</th>
                    <th>Leírás</th>
                    <th>Fájl</th>
                    <th>Felhasználó</th>
                    <th>Dátum</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-entry>
                <tr>
                    <td>{{ eventLabel(entry.event) }}</td>
                    <td>{{ descriptionLabel(entry) }}</td>
                    <td>{{ entry.subject?.name }}</td>
                    <td>{{ entry.causer?.name }}<br /><small>{{ entry.causer?.email }}</small></td>
                    <td>{{ entry.created_at | date:'yyyy.MM.dd HH:mm' }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5">Nincs megjeleníthető bejegyzés.</td>
                </tr>
            </ng-template>
        </p-table>
        }
    </div>
</p-dialog>

<p-dialog
    header="Feltöltési napló"
    [visible]="showLogs()"
    (visibleChange)="showLogs.set($event)"
    [modal]="true"
    [maximizable]="true"
    [style]="{width: '90vw', height: '90vh'}"
    [contentStyle]="{height: '100%', display: 'flex', flexDirection: 'column'}"
>
    <div class="p-4 border-bottom-1 surface-border">
        <p-iconField iconPosition="left">
            <p-inputIcon styleClass="pi pi-search" />
            <input name="logFilterText" type="text" pInputText placeholder="Szűrés (aktuális oldalon)..." [ngModel]="logFilterText()" (ngModelChange)="logFilterText.set($event)" class="w-full" />
        </p-iconField>
    </div>
    <div class="flex-1 overflow-hidden">
        @if (showLogs()) {
        <p-table
            [value]="filteredFilesystemEntries()"
            [lazy]="true"
            (onLazyLoad)="onFilesystemLazyLoad($event)"
            [paginator]="true"
            [rows]="filesystemMeta()?.per_page ?? 15"
            [totalRecords]="filesystemMeta()?.total ?? 0"
            [loading]="filesystemLoading()"
            [scrollable]="true"
            scrollHeight="flex"
            styleClass="p-datatable-sm"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Esemény</th>
                    <th>Leírás</th>
                    <th>Fájl</th>
                    <th>Felhasználó</th>
                    <th>Dátum</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-entry>
                <tr>
                    <td>{{ eventLabel(entry.event) }}</td>
                    <td>{{ descriptionLabel(entry) }}</td>
                    <td>{{ entry.subject?.name }}</td>
                    <td>{{ entry.causer?.name }}<br /><small>{{ entry.causer?.email }}</small></td>
                    <td>{{ entry.created_at | date:'yyyy.MM.dd HH:mm' }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5">Nincs megjeleníthető bejegyzés.</td>
                </tr>
            </ng-template>
        </p-table>
        }
    </div>
</p-dialog>
